/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSignOut16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSignOut16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M3.333 10.667V5.333c0-.64.001-1.052.023-1.368.02-.304.056-.42.079-.475.135-.327.395-.587.721-.722.056-.023.172-.058.476-.08.316-.02.729-.021 1.368-.021h3.333V1.333H6c-1.243 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443C2 3.47 2 4.091 2 5.333v5.334c0 1.242 0 1.863.203 2.353.27.654.79 1.173 1.443 1.444.49.203 1.111.203 2.354.203h3.333v-1.334H6c-.64 0-1.052 0-1.368-.022-.304-.02-.42-.056-.476-.08a1.334 1.334 0 0 1-.721-.72c-.023-.056-.059-.172-.08-.476a22.556 22.556 0 0 1-.022-1.368Z"
                fill="currentColor"
            />
            <path
                d="m10.586 5.805.943-.943L14.667 8l-3.138 3.138-.943-.943 1.528-1.528H5.98V7.333h6.134l-1.528-1.528Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSignOut24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSignOut24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M5 16V8c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C7.42 4.001 8.04 4 9 4h5V2H9c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 3.303 4.47C3 5.204 3 6.136 3 8v8c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C6.204 22 7.136 22 9 22h5v-2H9c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C5.001 17.578 5 16.96 5 16Z"
                fill="currentColor"
            />
            <path
                d="m15.879 8.707 1.414-1.414L22 12l-4.707 4.707-1.414-1.414L18.172 13H8.969v-2h9.203l-2.293-2.293Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSignOut = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSignOut(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconSignOut16 {...iconProps} />;
        case '24':
            return <IconSignOut24 {...iconProps} />;
        default:
            return <IconSignOut24 {...iconProps} />;
    }
});
